import React, { useEffect, useRef, useState } from "react";
import { eve, help, stopBtn } from "../../../../utils";
import { Dispatch, SetStateAction } from "react";
import {logDebug, logTrace} from "../../../../utils/logger";
import {getDeviceType} from "../../../../utils/systemInfo";
import {deviceType} from "../../../../constants";
import {useAppContext} from "../../../../AppDataContext";

interface InputProps {
    userInput: string;
    onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    handleInput: (
        e: React.KeyboardEvent<HTMLTextAreaElement>,
        fetchData: boolean
    ) => void;
    handleButtonClick: () => void;
    load: boolean;
    resetUserInput: () => void;
    fetchData: boolean;
    setFetchData: Dispatch<SetStateAction<boolean>>;
    stopFetchingHandler: () => void;
    setInputRef: (ref: React.RefObject<HTMLTextAreaElement>) => void;
    article_index: string | undefined;
}

const Input = ({
    userInput,
    onInputChange,
    handleInput,
    handleButtonClick,
    load,
    resetUserInput,
    stopFetchingHandler,
    setInputRef,
    article_index
}: InputProps) => {
    const locale_messages = new Map<string, any>(Object.entries(require('../../../../ds/locale.json')));
    const AppDataContext =  useAppContext()
    const languageKey = AppDataContext.language_for_chat || "EN";
    const inputPlaceholder = locale_messages.get(languageKey)?.input_placeholder;
    const localInputRef = useRef<HTMLTextAreaElement>(null);
    const [inputHeight, setInputHeight] = useState<string>("16px"); // Initial height
    const [TextHeight, setTextHeight] = useState<string>("48px"); // Initial height
    const [placeHolder, setPlaceHolder] = useState<string>(inputPlaceholder); // set placeholder based on language

    // Effect to set input ref
    useEffect(() => {
        if (setInputRef) {
            setInputRef(localInputRef);
        }
    }, [setInputRef]);

      useEffect(() => {
          const text = document.querySelector('.text') as HTMLElement
          if (text) {
              // Get the computed styles of the element
              const computedStyle = window.getComputedStyle(text);

              // Get the background gradient (CSS variable)
              const backgroundGradient = computedStyle.getPropertyValue('--backgroundClr2').trim();

              // Check if the background is a gradient and modify it
              if (backgroundGradient.startsWith('linear-gradient') || backgroundGradient.startsWith('radial-gradient')) {
                  // Find rgba or hsla in the gradient string and replace the alpha value with 1
                  const updatedGradient =
                      backgroundGradient.replace(/(rgba\([\d, ]+,[ ]?)([\d\.]+)(\))/g,
                          (match, p1, p2, p3) => {
                      return p1 + '1' + p3; // Set opacity to 1
                  });

                // Set the updated gradient back to the element's background
                text.style.background =  "var(--disclaimerBackgroundClr)"//updatedGradient;
                  // Log or use the CSS variable value
                  logDebug('Background color for Text before and after fix:', backgroundGradient, updatedGradient);
              }
          }
      }, []);
    // Dynamically adjust height based on content
    useEffect(() => {
        const input = localInputRef.current;
        if (input) {

            input.style.height = "auto"; // Reset the height to auto to shrink if needed
            input.style.height = `${input.scrollHeight}px`; // Adjust height based on content
            setInputHeight(`${input.scrollHeight}px`); // Set the height to the state
            setTextHeight(`${input.clientHeight}px`); // Set the height to the state
            input.scrollTop  = 10;
        }
    }, [userInput]);

    //adjust roundForArrow position based on input height
    useEffect(() => {
        const roundForArrow = document.querySelector('.roundForArrow') as HTMLElement
    if (roundForArrow) {
        // Dynamically adjust the bottom position based on TextHeight - 48px base height of input box
          roundForArrow.style.bottom = ` calc( 80px - 48px + ${TextHeight})`;
          logDebug("roundForArrow offsetHeight:", roundForArrow.style.bottom);
    }
    }, [TextHeight]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
   if ((e.key === "Enter" && e.shiftKey) ||
  (e.key === "Enter" &&
   [deviceType.mobile, deviceType.tablet].includes(getDeviceType())))
    {
        logDebug("Enter key pressed with shift or on mobile/tablet device");
        e.preventDefault();
        const input = localInputRef.current;
        if (input) {
            const start = input.selectionStart ?? 0;
            const end = input.selectionEnd ?? 0;
            const value = input.value;

            // Insert a newline at the cursor position
            input.value = value.substring(0, start) + "\n" + value.substring(end);

            // Move the cursor to the position after the new line
            input.selectionStart = input.selectionEnd = start + 1;

            // Store the current scroll position
            const scrollPosition = input.scrollTop;

            // Adjust the scroll position after the DOM updates
            requestAnimationFrame(() => {
                input.scrollTop = scrollPosition;
            });

            // Trigger the onInputChange handler
            onInputChange({ ...e, target: input } as React.ChangeEvent<HTMLTextAreaElement>);
        }
    } else if (!load && e.key === "Enter") {
        e.preventDefault();
        handleInput(e, true);
        resetUserInput();
    }
};


    return (
        <div className="text"
             style=
                 {{position:"absolute",
                     height:TextHeight ,
                     marginBottom:"30px"  }}>
            <section className="inputSection" style={{ position: "relative" }}>
                <div className="quest">
                    <img src={help} alt="help button" width="20px" height="20px" />
                    <span>Tips</span>
                </div>
                <textarea
                    className="input"
                    placeholder={placeHolder}
                    value={userInput}
                    onChange={onInputChange}
                    onKeyPress={handleKeyPress}
                    ref={localInputRef}
                    style={{
                        height: inputHeight,
                        overflowY: "auto", // Enable vertical scrolling
                        position: "relative",
                        bottom: "15px", // Fix the bottom of the textarea
                        // top: "auto", // Let the top grow
                        transition: "height 0.2s ease", // Smooth transition
                    }}
                />
            </section>
            <section
                className="sendButtonSection"
                style={load ? { background: "none" } : {}}
                  onClick={load ? stopFetchingHandler : () => {
                    handleButtonClick();
                    resetUserInput();
                }}
            >
                {load ? (
                    <img
                        src={stopBtn}
                        alt="button"
                        className="stopSendingButton"
                    />
                ) : (
                    <img
                        src={eve}
                        alt="button"
                    />
                )}
            </section>
        </div>
    );
};

export default Input;